"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusTrap = void 0;
const react_1 = require("react");
const utils_1 = require("@hivebrite/utils");
/**
 * Focus trap hook that keeps focus within a container element.
 * This hook is copied from the cookie banner package and should be moved to a shared package.
 */
const useFocusTrap = (containerRef, isActive) => {
    (0, react_1.useEffect)(() => {
        const containerElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (!isActive || !containerElement) {
            return undefined;
        }
        const focusableElements = (0, utils_1.getFocusableElements)(containerElement);
        const firstFocusable = focusableElements[0];
        const handleTabKey = (event) => {
            if (event.key !== 'Tab') {
                return;
            }
            // Prevent default Tab behavior and force focus back to container
            if (!(containerElement === null || containerElement === void 0 ? void 0 : containerElement.contains(document.activeElement))) {
                event.preventDefault();
                firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
                return;
            }
            event.preventDefault();
            const direction = event.shiftKey ? -1 : 1;
            const nextElement = (0, utils_1.getNextFocusableElement)(containerElement, direction);
            nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
        };
        const handleFocus = (event) => {
            if (!(containerElement === null || containerElement === void 0 ? void 0 : containerElement.contains(event.target))) {
                firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
            }
        };
        // Only focus the first element if nothing inside is already focused
        const focusTimeout = setTimeout(() => {
            if (!containerElement.contains(document.activeElement)) {
                firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
            }
        }, 50);
        document.addEventListener('keydown', handleTabKey);
        document.addEventListener('focusin', handleFocus);
        return () => {
            clearTimeout(focusTimeout);
            document.removeEventListener('keydown', handleTabKey);
            document.removeEventListener('focusin', handleFocus);
        };
    }, [containerRef, isActive]);
};
exports.useFocusTrap = useFocusTrap;
//# sourceMappingURL=index.js.map